import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const getAllUsers = createAsyncThunk('UserSlice/getAllUsers', async (value) => {
  value.isDescending = value.isDescending ? value.isDescending : false;
  value.sortType = value.sortType ? value.sortType : '';
  const response = await axios.get(
    `GetADDetails/getUsers?OU=${value.ouName}&FQDN=${value.fqdn}&page=${value.page}&pageSize=${value.pageSize}&searchSubstring=${value.searchQuery}&isDescending=${value.isDescending}&sortType=${value.sortType}&UserStatus=${value.usersFilter}`
  );
  return response.data;
});
//Geting Export User's data
export const getExportUsers = createAsyncThunk('UserSlice/getExportUsers', async (value) => {
  const response = await axios.get(
    `GetADDetails/exportusers?OU=${value.ouName}&FQDN=${value.fqdn}&searchSubstring=${value.searchQuery}&UserStatus=${value.usersFilter}`
  );
  return response.data;
});
//Get Single User
export const getSingleUser = createAsyncThunk('UserSlice/getSingleUser', async (value) => {
  const response = await axios.get(
    `GetADDetails/getSingleUser?userName=${encodeURIComponent(value.userName)}&FQDN=${value.fqdn}&domainId=${
      value.domainId
    }`
  );
  return { status: response.status, data: response.data };
});

//Edit User
export const editUserData = createAsyncThunk('userSlice/editUserData', async (values) => {
  try {
    const response = await axios.put(
      `GetADDetails/EditUser?userName=${encodeURIComponent(values.dn)}&FQDN=${values.updateUser[0].fqdn}`,
      values
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
//Get Attributes
export const getAttributes = createAsyncThunk('UserSlice/getAttributes', async (value) => {
  const response = await axios.get(`UserAttributes/getattributes?domainId=${Number(value)}`);
  return { status: response.status, data: response.data };
});

//Get Upn Suggestions
export const getUpnSuggestions = createAsyncThunk('UserSlice/getUpnSuggestions', async (fqdn) => {
  const response = await axios.get(`UserAttributes/getupnsuffix?FQDN=${fqdn}`);
  return response.data;
});

//add Attribute
export const addAttribute = createAsyncThunk('userSlice/addAttribute', async (value) => {
  try {
    const response = await axios.put(`UserAttributes/addattributes`, value);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
//check Attribute
export const checkAttribute = createAsyncThunk('userSlice/checkAttribute', async (value) => {
  try {
    const response = await axios.get(`UserAttributes/attributeSyntax?FQDN=${value.fqdn}&attribute=${value.attribute}`);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});
//Unlock User
export const UnLockUser = createAsyncThunk('userSlice/UnLockUser', async (value) => {
  try {
    const response = await axios.put(`GetADDetails/unlockUser`, value);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
//Bulk AttributeUpdate
export const bulkAttributeUpdate = createAsyncThunk('userSlice/bulkAttributeUpdate', async (value) => {
  try {
    const response = await axios.put(`GetADDetails/bulkuserattribute`, value);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});

//Bulk Enable User
export const bulkEnable = createAsyncThunk('userSlice/bulkEnable', async (value) => {
  try {
    const response = await axios.put(`GetADDetails/bulkenable`, value);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
//Bulk Disbale User
export const bulkDisable = createAsyncThunk('userSlice/bulkDisable', async (value) => {
  try {
    const response = await axios.put(`GetADDetails/bulkDisable`, value);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
//Enable or Disbale User
export const EnableDisableUser = createAsyncThunk('userSlice/UnLockUser', async (value) => {
  try {
    const response = await axios.put(
      `GetADDetails/enableOrDisable?UserName=${encodeURIComponent(value.user)}&FQDN=${value.fqdn}&notifyEmail=${
        value.notifyEmail
      }&DomainId=${value.domainId}`
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
export const getLockOrDisable = createAsyncThunk('userSlice/getLockOrDisable', async (value) => {
  try {
    const response = await axios.get(
      `GetADDetails/enableandlock?userName=${encodeURIComponent(value.user)}&FQDN=${value.fqdn}&type=${value.type}`
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});
//Delete User
export const deleteUserData = createAsyncThunk('userSlice/deleteUserData', async (value) => {
  try {
    const response = await axios.delete(`GetADDetails/deleteUser`, {
      params: { FQDN: value.fqdn },
      data: value.dn,
    });
    return { status: response.status, data: response.data };
  } catch (err) {
    throw err;
  }
});
const initialState = {
  data: [],
  totalCount: 0,
  totalPages: 0,
  loading: false,
  error: null,
  singleUserLoading: false,
  singleUserError: null,
  singleUserData: null,
  selectedItems: [],
  selectedItemsValues: [],
  userAttributesLoading: false,
  userAttributes: [],
  userAttributesError: null,
  upnSuggestions: [],
};

const getUsersSlice = createSlice({
  name: 'getUsers',
  initialState,
  reducers: {
    setSelectedItems: (state, action) => {
      state.selectedItems = action.payload;
    },
    setSelectedItemsValues: (state, action) => {
      state.selectedItemsValues = action.payload;
    },
    resetsingleUserData: (state) => {
      state.singleUserData = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAllUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.userList;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
        state.error = null;
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.data = [];
        state.error = action.error.message;
      })
      .addCase(getSingleUser.pending, (state) => {
        state.singleUserLoading = true;
      })
      .addCase(getSingleUser.fulfilled, (state, action) => {
        state.singleUserLoading = false;
        state.singleUserData = action.payload.data;
        state.singleUserError = null;
      })
      .addCase(getAttributes.pending, (state) => {
        state.userAttributesLoading = true;
        state.userAttributes = [];
        state.userAttributesError = null;
      })
      .addCase(getAttributes.fulfilled, (state, action) => {
        state.userAttributesLoading = false;
        state.userAttributes = JSON.parse(action.payload.data.addedAttributes);
        state.userAttributesError = null;
      })
      .addCase(getAttributes.rejected, (state, action) => {
        state.userAttributesLoading = false;
        state.userAttributes = [];
        state.userAttributesError = action.error.message;
      })
      .addCase(getUpnSuggestions.fulfilled, (state, action) => {
        state.upnSuggestions = action.payload;
      });
  },
});
export default getUsersSlice.reducer;
export const { setSelectedItems, setSelectedItemsValues, resetsingleUserData } = getUsersSlice.actions;
